import styled, { css, keyframes } from 'styled-components';
import { ifProp, palette, switchProp, theme } from 'styled-tools';

const loadingAnimation = keyframes`
from {
    left: -130%
}
to {
    left: 130%
}
`;

export const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 45px;
  position: relative;
  z-index: ${({ zIndex }) => zIndex || 0};
  border-radius: 50px;
  background-color: ${ifProp(
    'withBg',
    palette('textContrast3'),
    palette('colorButtonPrimary')
  )};
  color: ${palette('textContrast1')};
  font-size: ${theme('fontSize.md')};
  font-weight: ${theme('fontWeight.bold')};
  vertical-align: middle;
  letter-spacing: 3px;
  ${ifProp(
    'border',
    css`
      border: 2px solid;
      border-color: ${({ colorWithBadge, color, showBadge }) =>
        showBadge ? palette(colorWithBadge) : palette(color)};
    `
  )}
  ${ifProp(
    'group',
    css`
      margin-left: -4px;
      margin-right: -4px;
    `
  )}
  ${ifProp(
    'onClick',
    css`
      cursor: pointer;
    `
  )}
  ${ifProp(
    'link',
    css`
      cursor: pointer;
    `
  )}
  ${switchProp('size', {
    sm: css`
      width: 28px;
      height: 28px;
      border-width: 1px;
      font-size: ${theme('fontSize.xxs')};
      letter-spacing: 1px;
    `,
  })}
  span {
    height: 100%;
    width: 100%;
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: 50px;
    background-color: transparent;
    background-color: ${palette('bgBodyTransparent')};
    &:after {
      content: ' ';
      display: block;
      position: absolute;
      width: 90px;
      height: 45px;
      top: -5%;
      left: -130%;
      z-index: 8;
      animation: 1.2s linear 0s infinite none running ${loadingAnimation};
      background: linear-gradient(
        90deg,
        transparent 0%,
        ${palette('bgButtonSecondaryHover')} 35%,
        ${palette('bgButtonSecondaryHover')} 55%,
        transparent 100%
      );
    }
    &:before {
      content: ' ';
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 10;
      background: linear-gradient(
          0deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0) 100%
        ),
        url(${({ img }) => img});
      background-position: center;
      background-size: cover;
      animation: background 5s;
    }
  }
  svg {
    position: absolute;
    z-index: 20;
    top: -5px;
    right: 0;
    width: 15px;
    height: 15px;
    color: ${palette('white')};
    background-color: ${({ colorWithBadge }) => palette(colorWithBadge)};
    border-radius: 50%;
  }
`;
